"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AppAccess {
    static can3pl = 'can3pl';
    static canOrderManager = 'canOrderManager';
    static canBilling = 'canBilling';
    static canNetworkManager = 'canNetworkManager';
    static canWarehouseManagerClassicAdmin = 'canWarehouseManagerClassicAdmin';
    static canWarehouseManagerUnlimitedAdmin = 'canWarehouseManagerUnlimitedAdmin';
    static canWarehouseManagerCustomerPortal = 'canWarehouseManagerCustomerPortal';
    static canWarehouseManagerIntegrations = 'canWarehouseManagerIntegrations';
    static canWarehouseManagerMobile = 'canWarehouseManagerMobile';
    static canWarehouseManagerAccountManager = 'canWarehouseManagerAccountManager';
    static canIntegrationManager = 'canIntegrationManager';
    static canSignUp = 'canSignUp';
    static canManagementConsole = 'canManagementConsole';
    static canSmallParcel = 'canSmallParcel';
    static canAdmin = 'canAdmin';
    static canFM = 'canFM';
    static canSmartScan = 'canSmartScan';
    static canAccountingIntegration = 'canAccountingIntegration';
    static canBusinessAnalytics = 'canBusinessAnalytics';
    static allAppAccessNames = Object.values(AppAccess);
    static appAccessValid(appAccess) {
        let result = false;
        if (!appAccess) {
            return result;
        }
        if (appAccess.length == 0) {
            return true;
        }
        for (const tmpAccess of appAccess) {
            if (AppAccess.allAppAccessNames.includes(tmpAccess)) {
                result = true;
                continue;
            }
            return false;
        }
        return result;
    }
}
exports.default = AppAccess;
